<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a
        href="javascript:history.go(-1)"
        >{{ $t("anonymou_currpage") }}</a
      >
      <img src="../../assets/img/jt.gif" />{{ $t("document_sea_title") }}
    </div>
  <table-no-record v-if="JSON.stringify(Entity)=='{}'"></table-no-record>
      <!--table-->
      <div v-if="JSON.stringify(Entity)!='{}'">
   
      <table width="98%" cellpadding="0" cellspacing="0">
        <!--第一排-->
        <tr>
          <td width="25%" align="left">
            <b> {{ $t("normal_billtype") }}:</b> &nbsp;
             <span>{{Entity.billType}}</span>
          </td>
          <td width="25%" align="left">
            <b>{{ $t("inputno") }}:</b> &nbsp;
            <span>{{Entity.houseNo}}</span>
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_mawb") }}:</b> &nbsp;
             <span>{{Entity.masterNo}}</span>
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_billdate") }}:</b> &nbsp;
             <span>{{Entity.billDate}}</span>
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td class="tr2" width="15%">{{ $t("normal_shprcode") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
               <span>{{Entity.shprCode}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shprename") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <span>{{Entity.shprEname}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shpradd") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
            <span>{{Entity.ShprEaddr}}</span>
            </td>
          </tr>

          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneecode") }}:</td>
            <td valign="middle" align="left">
                <span>{{Entity.CneeCode}}</span>
            </td>
         
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_consignee") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <span>{{Entity.cneeEname}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneeadd") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
                <span>{{Entity.cneeEaddr}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="50%" align="left">
            <b> {{ $t("vessel") }}/{{ $t("voyage") }}:</b> &nbsp;
               <span>{{Entity.vessel}}</span>
            &nbsp;
               <span>{{Entity.voyage}}</span>
          </td>
          <td width="50%" align="left">
            <b>{{ $t("Carrier") }}:</b> &nbsp;
             <span>{{Entity.carrCode}}</span>
            &nbsp;
             <span>{{Entity.carrName}}</span>
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("normal_sea_closedate") }} :
            </td>
            <td width="25%" valign="middle">
            <span>{{Entity.closingDate}}</span>
            </td>
            <td width="15%" valign="middle">{{ $t("normal_sea_portre") }}</td>
            <td width="45%" valign="middle">
             <span>{{Entity.porCode}}</span>
              &nbsp;
             <span>{{Entity.porDescp}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_etd") }}:</td>
            <td valign="middle">
              <span>{{Entity.etdDate}}</span>
            </td>
            <td valign="middle">{{ $t("normal_sea_portl") }}:</td>
            <td valign="middle">
               <span>{{Entity.polCode}}</span>
              &nbsp;
              <span>{{Entity.polDescp}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_eta") }}:</td>
            <td valign="middle">
               <span>{{Entity.etaDate}}</span>
            </td>
            <td valign="middle">{{ $t("normal_sea_portdh") }} :</td>
            <td valign="middle">
                  <span>{{Entity.podCode}}</span>
              &nbsp;
                  <span>{{Entity.podDescp}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_loading") }}</td>
            <td valign="middle">
               <span>{{Entity.loadType1}}</span>
              &nbsp;
               <span>{{Entity.loadType2}}</span>
            </td>
            <td valign="middle">{{ $t("normal_sea_protdl") }}</td>
            <td valign="middle">
              <span>{{Entity.podyCode}}</span>
              &nbsp;
              <span>{{Entity.podyDescp}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left">
            <b>{{ $t("normal_pkg") }}:</b> &nbsp;
            <span>{{Entity.qty}}</span>
          </td>
          <td width="25%" align="left">
            <b> {{ $t("normal_pkgde") }}:</b> &nbsp;
            <span>{{Entity.qtyDescp}}</span>
          </td>
          <td width="50%">
            <b>{{ $t("normal_comm") }}:</b> &nbsp;
            <span>{{Entity.cmdtyName}}</span>
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("gw") }} :
            </td>
            <td width="18%" valign="middle">
              &nbsp;
                <span>{{Entity.gw}}</span>
            </td>
            <td width="15%" valign="middle" class="tr2">
              {{ $t("normal_sea_cbm") }}:
            </td>
            <td width="18%" valign="middle">
              &nbsp;
               <span>{{Entity.cbm}}</span>
            </td>
            <td width="15%" valign="middle" class="tr2">
              {{ $t("normal_sea_cbf") }}:
            </td>
            <td width="19%" valign="middle">
              &nbsp;
              <span>{{Entity.cuft}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("currency") }}:
            </td>
            <td valign="middle">
              &nbsp;
                <span>{{Entity.crncyCode}}</span>
            </td>
            <td valign="middle" class="tr2">{{ $t("freight") }}</td>
            <td valign="middle">
              &nbsp;
              <span>{{Entity.frtTerm}}</span>
            </td>
            <td valign="middle" class="tr2">{{ $t("other") }}</td>
            <td valign="middle">
              &nbsp;
                <span>{{Entity.othTerm}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("normal_marks") }}:
            </td>
            <td colspan="5" valign="middle" align="left">
              &nbsp;
                 <span>{{Entity.marks}}</span>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_descp") }}:</td>
            <td colspan="5" valign="middle" align="left">
              &nbsp;
              <span>{{Entity.goodsDescp}}</span>
            </td>
          </tr>
   
        </tbody>
      </table>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import { GetDeatils } from "@/api/branchBillOflading.js";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord
  },   
    data(){
      return{
        Entity:{},
        HouseNo:''
      }
    },
 async mounted() {
     this.HouseNo = this.$route.query.HouseNo;
    // console.log(this.$route.query.HouseNo);
    // // var self = this;
      await GetDeatils({'HouseNo':this.HouseNo}).then((res) => {
        
        if(res.code==200){
         

             this.Entity=res.data.tgAwbBlDtails;
      
         
          // console.log(this.Entity);
        }
      })
    }
}
</script>
<style lang="less">

</style>